import { useContext } from 'react';
import Swal from 'sweetalert2';
import { AuthContext } from '../contexts/AuthContext';

function Exit() {
    const { setIsLoggedIn } = useContext(AuthContext);

    return () => {
        let timerInterval;

        Swal.fire({
            title: "Sesión expirada",
            icon: "warning",
            html: "Tu sesión ha expirado, se cerrará en <b>8</b> segundos.",
            confirmButtonText: "Cerrar ahora",
            showLoaderOnConfirm: true,
            timer: 8000,
            timerProgressBar: true,
            showCloseButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
                confirmButton: 'auteco_button primary'
            },

            didOpen: () => {
                const timer = Swal.getHtmlContainer().querySelector("b");
                timerInterval = setInterval(() => {
                    timer.textContent = Math.ceil(Swal.getTimerLeft() / 1000);
                }, 1000);
            },
            willClose: () => {
                clearInterval(timerInterval);
            }
        }).then((result) => {
            if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
                setIsLoggedIn(false);
            }
        });
    };
}

export default Exit;
